export default class ScanFileStatus {
  hasSourceFile = false;
  hasProcessedFile = false;
  hasModelFile = false;
  hasExternalsFile = false;
  hasInternalsFile = false;
  hasSourceFrames = false;
  numberOfSourceFrames = 0;
  hasWebpFrames = false;
  numberOfWebPFrames = 0;
  hasWebpFrameThumbnails = false;
  numberOfWebPFrameThumbnails = 0;
  hasFrameRecords = false;
  numberOfFrameRecords = 0;
  hasCameraHelperRecords = false;
  numberOfCameraHelperRecords = 0;

  constructor(data) {
    if (!data) return;
    this.hasSourceFile = data.hasSourceFile ?? false;
    this.hasProcessedFile = data.hasProcessedFile ?? false;
    this.hasModelFile = data.hasModelFile ?? false;
    this.hasExternalsFile = data.hasExternalsFile ?? false;
    this.hasInternalsFile = data.hasInternalsFile ?? false;
    this.hasSourceFrames = data.hasSourceFrames ?? false;
    this.numberOfSourceFrames = data.numberOfSourceFrames ?? 0;
    this.hasWebpFrames = data.hasWebpFrames ?? false;
    this.numberOfWebPFrames = data.numberOfWebPFrames ?? 0;
    this.hasWebpFrameThumbnails = data.hasWebpFrameThumbnails ?? false;
    this.numberOfWebPFrameThumbnails = data.numberOfWebPFrameThumbnails ?? 0;
    this.hasFrameRecords = data.hasFrameRecords ?? false;
    this.numberOfFrameRecords = data.numberOfFrameRecords ?? 0;
    this.hasCameraHelperRecords = data.hasCameraHelperRecords ?? false;
    this.numberOfCameraHelperRecords = data.numberOfCameraHelperRecords ?? 0;
  }
}